import { type BackgroundFetch, LRUCache } from "lru-cache";

import { CACHE_DURATION } from "@onesolution/constants";

const options = {
	ttl: CACHE_DURATION, // a day,
	ttlAutopurge: true,
};

const _cache = new LRUCache(options);

Object.assign(_cache, {
	async getOrSet<T extends BackgroundFetch<object>>(
		key: string,
		getDataFn: () => Promise<T>,
	) {
		let dataInCache = cache.get(key) as T;

		if (!dataInCache) {
			dataInCache = await getDataFn();

			cache.set(key, dataInCache);
		}

		return dataInCache;
	},
});

export const cache = _cache as typeof _cache & {
	getOrSet: <T>(key: string, getDataFn: () => Promise<T>) => Promise<T>;
};

export const CACHE_KEYS = {
	userServices: "userServices",
	formattedBoard: "formattedBoard",
	clientInfos: "clientInfos",
};
